import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gs2006',
    ecrans: ['00-2'],
     params:['id']
});
